/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
import React, { useEffect, useState, useRef } from "react";
import { observer } from "mobx-react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Utils from "Utils/utils";
import { withRouter, useParams } from "react-router-dom";
import BreadCrumbComponent from "Components/common/breadcrumb";
import ButtonComponent from "Components/common/Button";
import DropdownMenuComponent from "Components/common/DropDownMenu";
import { ReactComponent as SequenceIcon } from "Assets/svg/sequence.svg";
import FolderComponent from "./SequencePage/SequenceFolder";
import SequenceProperties from "./SequencePage/sequenceProperties";
import NoSequenceComponent from "./SequencePage/NoSequence";
import CopilotBanner from "./SequencePage/CopilotBanner";
import SequenceTable from "./SequencePage/SequenceTable";
import copilotStore from "Stores/copilotStore";
import { sequenceStoreData } from "Stores/sequenceData";
import { URLS, makeApi } from "Utils/apiURL";
import { checkTeamSubscriptionActive } from "Utils/commonAPI";
import { SequenceTableLoading } from "./SequencePage/SequenceTableLoading";
import NoSharedEntity from "Components/common/NoSharedEntity";
import { userDetail } from "Stores/userDetail";
import DriverMaster from "Components/driver/Driver";
import ContactCard from "Components/ContactCard/ContactCard";
import PricingDiscountBanner from "Components/common/PricingDiscountBanner";
import { upgradePopupState } from "Components/Paywall/UpgradePopup";
import { SequenceUtils } from "Utils/SequenceUtils";
import KnowMoreButton from "Components/common/KnowMoreButton";
import { seqTemplatePopupState } from "./SequenePredefinedTemplate/SeqTemplatePopupState";
import globalCallState from "Stores/GlobalCallState";
import PaywallUtils from "Utils/PaywallUtils";
import { toJS } from "mobx";
import PageLimit from "Components/common/PageLimit";
import PaginationComponent from "Components/common/PaginationComponent";

const defaultBreadValue = [{ name: "Sequences", link: "/sequences/all" }];

let isFolder = false;
let folderIdFromURL = "";
let locationId = "";
let propsMatchParam;
let isShared = false;

const Sequence = props => {
  const sequenceContactCardRef = useRef();
  let { id: seqId, sharedId } = useParams();

  if (typeof seqId === "undefined") {
    seqId = sharedId;
  }

  const {
    noOfSequencesEligible = 0,
    noOfSequencesUsed = 0,
    inFreePlan = false,
    taskEnabled = false,
    planName = ""
  } = userDetail.userFeatureFlag || {};

  const [showAddDropdown, setAddDropdown] = useState(false);
  const [breadcrumbArr, setBreadCrumbArr] = useState(defaultBreadValue);
  const [showFolderLoader, setShowFolderLoader] = useState(true);
  const [showNoSequence, setNoSequence] = useState(false);
  const [showCreateSeq, setCreateSeq] = useState(false);
  const [showCreateSeqPopup, setCreateSeqPopup] = useState(false);
  const [showcreateFolder, setCreateFolder] = useState(false);
  const [showSequenceProp, setSequenceProp] = useState(false);
  const [sequenceTableLoading, setSequenceTableLoading] = useState(true);
  const [sequenceData, setSequenceData] = useState([]);
  const [newSeqName, setNewSeqName] = useState("New Sequence");
  const [showNoSharedSequence, setNosharedSequence] = useState(false);
  const [showSharedBadge, setShowSharedBadge] = useState(false);
  const [showContactCard, setShowContactCard] = useState(false);
  const [slideAnim, setSlideAnim] = useState(false);
  const [selectedContact, setSelecedContact] = useState({});
  const [productDiscount, setProductDiscount] = useState(
    Utils.showProductDiscountBanner()
  );
  const [sortIconStatus, setSortIconStatus] = useState("ASC");
  const [activeSort, setActiveSort] = useState("CREATE_TS");
  const [breadcrumbLoading, setBreadcrumbLoading] = useState(false);
  const [selectedTemplateSequenceData, setSelectedTemplateSequence] = useState(
    []
  );

  const checkEligibleSequenceCount = () => {
    let count = noOfSequencesEligible - noOfSequencesUsed;
    return count > 0;
  };

  const constructPropsMatchParam = (propsVal = props) => {
    propsMatchParam =
      propsVal && propsVal.match && propsVal.match.params
        ? propsVal.match.params
        : {};
    if (propsMatchParam) {
      if (propsMatchParam.id && propsMatchParam.folderId) {
        isFolder = true;
        folderIdFromURL = propsMatchParam.folderId;
        locationId = propsMatchParam.id;
        isShared = false;
        setSequenceProp(true);
      } else if (propsMatchParam.folderId) {
        isFolder = true;
        folderIdFromURL = propsMatchParam.folderId;
        locationId = "";
        isShared = false;
        setSequenceProp(false);
      } else if (propsMatchParam.id || propsMatchParam.sharedId) {
        locationId = propsMatchParam.id || propsMatchParam.sharedId;
        setSequenceProp(true);
        folderIdFromURL = "";
        isFolder = false;
        if (propsMatchParam.sharedId) {
          isShared = true;
        }
      } else if (props.shared) {
        locationId = "";
        isShared = true;
        isFolder = false;
        folderIdFromURL = "";
        setSequenceProp(false);
      } else {
        locationId = propsMatchParam.id ? propsMatchParam.id : "";
        isFolder = false;
        isShared = false;
        folderIdFromURL = "";
        setSequenceProp(false);
      }
    }
  };

  const checkSequenceLeft = () => {
    return noOfSequencesEligible - noOfSequencesUsed > 0;
  };

  const enableDropdownMenu = () => {
    DriverMaster.killDriver();
    if (checkSequenceLeft) {
      setAddDropdown(true);
    }
  };

  const hideDropdownMenu = () => {
    setAddDropdown(false);
  };

  const setBreadCrumbData = curBreadValue => {
    setBreadCrumbArr([...curBreadValue]);
  };

  // SG-2182: both the empty-state and existing-user banner "Create Sequence"
  // actions open a brand-new Copilot conversation with an auto-sent opening
  // message, instead of the manual templates/AI popup. Also passes along the
  // folder the user was browsing (if any) so the created sequence lands
  // there instead of the default unfiled location.
  const openCopilotForSequence = () => {
    copilotStore.setPendingAutoSend("Help me build a sequence.");
    // eslint-disable-next-line no-console
    console.log("[SG-2182] openCopilotForSequence — folderIdFromURL:", folderIdFromURL);
    if (folderIdFromURL) {
      copilotStore.setPendingFolderId(folderIdFromURL);
    }
    props.history.push("/copilot/new");
  };

  const openCreateSequencePopup = async () => {
    DriverMaster.killDriver();
    if (await checkTeamSubscriptionActive()) {
      if (checkEligibleSequenceCount()) {
        setNoSequence(false);
        setAddDropdown(false);
        seqTemplatePopupState.setAction("");
        setCreateSeqPopup(true);
      } else {
        setAddDropdown(false);
        if (!upgradePopupState.showPopup) {
          PaywallUtils.upgradeUtilsFunction(
            "newSequence",
            false,
            planName,
            inFreePlan,
            { sequenceCount: noOfSequencesEligible }
          );
        }
      }
    }
  };

  const createNewFolderBtn = async () => {
    setAddDropdown(false);
    if (await checkTeamSubscriptionActive()) {
      setCreateFolder(true);
    }
  };

  const dropdownOptions = [
    {
      icon: {
        ele: <SequenceIcon />,
        style: { width: "14px", height: "14px" }
      },
      value: "New Sequence",
      key: "ceateNewSequence",
      method: openCreateSequencePopup,
      showUpgrade: inFreePlan && !checkEligibleSequenceCount(),
      closeDropdown: setAddDropdown,
      type: "newSequence"
    },
    {
      icon: {
        ele: '<i style="font-size: 16px" class="material-icons-outlined list-icon">create_new_folder</i>',
        style: {}
      },
      value: "New Folder",
      key: "createNewSequenceFolder",
      method: createNewFolderBtn
    }
  ];

  const constructSequenceData = response => {
    const respData = response;
    let finalData = [];
    if (response.length) {
      respData.map(value => {
        let sequenceData = {};
        if (value?.name) {
          const {
            id,
            folderId,
            clickCount,
            contactsAdded,
            name,
            openCount,
            replyCount,
            steps,
            status,
            sentCount,
            accessType,
            shareType,
            owner,
            memberId,
            createTs,
            scheduleWindowId = "",
            firstStageIsReply = false,
            inboxIds = [],
            settings,
            excludeContactEnabled,
            pauseStatus = "",
            resumeStatus = "",
            emailValidationEnabled = false,
            stopEmailOnMeetingBooked = false,
            stopEmailOnReplyReceived = false,
            stopEmailOnLinkedInReplyReceived = false
          } = value || {};
          let background = SequenceUtils.getSequenceStatus(value);
          sequenceData = {
            id,
            folderId,
            clickCount,
            contactsAdded,
            name,
            openCount,
            replyCount,
            sentCount,
            status,
            accessType,
            shareType,
            owner,
            memberId,
            createTs,
            scheduleWindowId,
            inboxIds,
            firstStageIsReply,
            settings,
            steps: steps || {},
            excludeContactEnabled,
            pauseStatus,
            resumeStatus,
            background,
            emailValidationEnabled,
            stopEmailOnMeetingBooked,
            stopEmailOnReplyReceived,
            stopEmailOnLinkedInReplyReceived
          };
          finalData.push(sequenceData);
        }
      });
      sequenceStoreData.setPaginationDataLoading(false);
      if (finalData.length) {
        constructBreadCrumbData(finalData);
        setSequenceData(finalData);
        setNoSequence(false);
        setNosharedSequence(false);
        setSequenceTableLoading(false);
      } else if (finalData.length === 0) {
        setSequenceData([]);
        setNoSequence(true);
        setSequenceTableLoading(false);
      }
    } else {
      setNoSequence(true);
      setSequenceData([]);
      setSequenceTableLoading(false);
    }
  };

  const getFolderSequenceResponse = (folderId, externalPayload = null) => {
    folderId ? sequenceStoreData.setFolderId(folderId) : "";
    sequenceStoreData.setIsSharedSeqFolder(false);
    const folderRespCbk = (folderData = []) => {
      if (folderData?.length) {
        sequenceStoreData.setSequenceData(folderData);
        SequenceUtils.addActiveSequenceIdToLocalStorage(folderData);
        constructSequenceData(folderData, false);
        setNoSequence(false);
      } else {
        setNoSequence(true);
        setSequenceData([]);
        setSequenceProp(false);
        setSequenceTableLoading(false);
        sequenceStoreData.setPaginationDataLoading(false);
      }
    };
    if (externalPayload && Object.keys(externalPayload).length > 0) {
      Utils.getFolderSequenceResponse(folderId, folderRespCbk, externalPayload);
    } else {
      Utils.setPaginationDefaults();
      const payload = Utils.constructPayload({
        folderId: sequenceStoreData?.folderId
      });
      Utils.getFolderSequenceResponse(folderId, folderRespCbk, payload);
    }
  };

  const getFolderDetailForBreadcrumb = () => {
    let selectedFolderName = "",
      selectedFolderId = "";
    if (isShared) {
      selectedFolderName = "Shared Sequences";
      selectedFolderId = "shared";
    } else {
      const selectedFolderDetails =
        sequenceStoreData?.allFolderResponse?.length > 0
          ? sequenceStoreData?.allFolderResponse?.filter(
              item => item?.id === folderIdFromURL
            )[0]
          : {};
      selectedFolderName = selectedFolderDetails?.folderName || "My Sequences";
      selectedFolderId = selectedFolderDetails?.id || "all";
    }
    return { selectedFolderName, selectedFolderId };
  };

  const constructBreadCrumbData = store => {
    let curBreadValue = JSON.parse(JSON.stringify(defaultBreadValue));
    const { selectedFolderId = "", selectedFolderName = "" } =
      getFolderDetailForBreadcrumb();
    if (selectedFolderName) {
      curBreadValue.push({
        name: selectedFolderName,
        link: "/sequences/" + selectedFolderId
      });
    }
    if (store?.length && locationId !== "") {
      const storeData = JSON.parse(JSON.stringify(store));
      const storeLength = storeData?.length;
      let cureSeqName;

      for (let i = 0; i < storeLength; i++) {
        if (storeData[i]?.id === locationId && storeData?.[i]?.name) {
          cureSeqName = storeData[i].name;
        }
      }
      curBreadValue.push({ name: cureSeqName, link: "" });
    }
    if (curBreadValue?.length) {
      setBreadCrumbData(curBreadValue);
    }

    setBreadcrumbLoading(false);
  };

  const getSharedSeqResponse = async (externalPayload = null) => {
    let response;
    if (externalPayload && Object.keys(externalPayload).length > 0) {
      response = await getSharedSeqDataFromApi(externalPayload);
    } else {
      Utils.setPaginationDefaults();
      const payload = Utils.constructPayload({ sharedFolder: true });
      response = await getSharedSeqDataFromApi(payload);
    }
    sequenceStoreData.setIsSharedSeqFolder(true);
    sequenceStoreData.setFolderId("");
    if (response && response?.data) {
      const {
        sequences = [],
        totalPages = 1,
        totalSequences = 1,
        currentPage = 1
      } = response.data || {};
      if (totalSequences) {
        sequenceStoreData.setTotalSequences(totalSequences);
      }
      if (currentPage) {
        sequenceStoreData.setCurrentPage(currentPage);
      }
      if (totalPages) {
        sequenceStoreData.setTotalPage(totalPages);
      }
      sequenceStoreData.setPaginationDataLoading(false);
      if (sequences?.length) {
        sequenceStoreData.setSequenceData(sequences);
        setSequenceTableLoading(false);
        constructSequenceData(sequences);
        SequenceUtils.addActiveSequenceIdToLocalStorage(sequences);
      } else if (sequences?.length === 0) {
        sequenceStoreData.setSequenceData([]);
        setNosharedSequence(true);
      }
    } else {
      sequenceStoreData.setSequenceData([]);
      Utils.showApiFailureResponse(response);
    }
  };

  const getSharedSeqDataFromApi = (externalPayload = null) => {
    const config = {
      url: `${URLS.getMySequenceData}`,
      method: "POST",
      data: externalPayload
    };

    Utils.cancelPreviousSequenceRequest();
    return makeApi(config, sequenceStoreData.cancelSequenceCallAction);
  };

  const showAllSequenceData = (externalPayload = null) => {
    sequenceStoreData.setFolderId("");
    sequenceStoreData.setIsSharedSeqFolder(false);
    setSequenceProp(false);

    if (externalPayload && Object.keys(externalPayload).length > 0) {
      makeAllSequenceDataApi(externalPayload);
    } else {
      Utils.setPaginationDefaults();
      const payload = Utils.constructPayload();
      makeAllSequenceDataApi(payload);
    }
  };

  const makeAllSequenceDataApi = (payload = null) => {
    if (payload && Object.keys(payload).length > 0) {
      setSequenceTableLoading(true);
      sequenceStoreData.setPaginationDataLoading(true);
      const callback = () => {
        constructAllSeqData();
        setSequenceTableLoading(false);
        sequenceStoreData.setPaginationDataLoading(false);
      };
      sequenceStoreData.getAllSequenceData(callback, payload);
    }
  };

  const constructAllSeqData = () => {
    let duplicateStoreData = [];
    if (sequenceStoreData?.sequenceData)
      duplicateStoreData = JSON.parse(
        JSON.stringify(sequenceStoreData.sequenceData)
      );
    if (duplicateStoreData.length) {
      setNoSequence(false);
      constructSequenceData(duplicateStoreData);
      if (showSequenceProp && locationId) {
        constructBreadCrumbData(duplicateStoreData, locationId);
      }
    } else if (duplicateStoreData.length === 0) {
      setNoSequence(true);
      setSequenceData([]);
    }
  };

  const checkAndUpdate = () => {
    const folderDetailsObj = Utils.getFolderDetails();
    const folderName = folderDetailsObj.folderName;
    const folderId = folderDetailsObj.folderId;
    if (folderName && folderId) {
      getFolderSequenceResponse(folderId);
    } else makeAllSequenceDataApi(true);
  };

  const openContactCard = (contact = {}) => {
    if (contact && Object.keys(contact)?.length) {
      setSlideAnim(true);
      setShowContactCard(true);
      setSelecedContact(contact);
    }
  };

  const closeContactCard = () => {
    if (globalCallState.popupValues?.isContactCard) {
      globalCallState.setPopupValues({
        ...globalCallState.popupValues,
        isContactCard: false
      });
    }
    setSlideAnim(false);
    setTimeout(() => {
      setShowContactCard(false);
    }, 300);
  };

  const redirectToMySequence = value => {
    if (value) {
      props.history.push("/sequences/all");
    }
  };

  const sortSequence = (sortParam, toSort) => {
    setSequenceTableLoading(true);
    sequenceStoreData.setPaginationDataLoading(true);
    setActiveSort(sortParam);
    sequenceStoreData.setDynamicCurrentPage(1);
    const payload = {
      showReplySequence: true,
      sortDirection: toSort,
      pageNo: sequenceStoreData?.dynamicCurrentPage,
      limit: sequenceStoreData?.pageLimit,
      sortParam
    };

    if (folderIdFromURL) {
      payload.folderId = folderIdFromURL;
    } else if (isShared) {
      payload.sharedFolder = true;
    }
    const resCbk = (direction, value, dataList) => {
      if (value && direction === "ASC") {
        setSortIconStatus("DESC");
      } else if (value && direction === "DESC") {
        setSortIconStatus("ASC");
      }
      if (value) {
        setSequenceData(dataList);
      }
      setSequenceTableLoading(false);
      sequenceStoreData.setPaginationDataLoading(false);
    };
    sequenceStoreData.getSequenesBySorting(payload, resCbk);
  };

  const updateSequenceDataOnMoved = () => {
    let tempSeqLen = sequenceStoreData?.tempSequenceData?.length;
    let seqLen = sequenceStoreData?.sequenceData?.length;
    setSequenceData(sequenceStoreData.sequenceData);
    if (tempSeqLen && !seqLen) {
      setNoSequence(true);
    } else if (!tempSeqLen && seqLen) {
      setNoSequence(false);
    }
  };

  const reloadSequenceContactPage = (keyType = "", obj = {}) => {
    if (
      keyType?.toLowerCase() === "sequence_contact" &&
      obj?.sequenceId === seqId
    ) {
      sequenceStoreData.setReloadSequenceContactPage(true);
    }
  };

  const initCalls = async () => {
    await seqTemplatePopupState.getDomain();
  };

  useEffect(() => {
    const selectedTemplateSequence = toJS(
      sequenceStoreData.selectedTemplateSequence
    );
    if (Array.isArray(selectedTemplateSequence)) {
      setSelectedTemplateSequence(selectedTemplateSequence);
    }
  }, [sequenceStoreData.selectedTemplateSequence]);

  useEffect(() => {
    if (Array.isArray(selectedTemplateSequenceData)) {
      setSequenceData(prev => [...toJS(prev), ...selectedTemplateSequenceData]);
    }
  }, [selectedTemplateSequenceData]);

  useEffect(() => {
    constructBreadCrumbData(sequenceData);
  }, [sequenceData]);

  useEffect(() => {
    setShowSharedBadge(false);
    constructPropsMatchParam();
    constructBreadCrumbData(sequenceData);
    sequenceStoreData.setPaginationDataLoading(true);
    if (folderIdFromURL && !seqId) {
      setSequenceTableLoading(true);
      getFolderSequenceResponse(folderIdFromURL);
    } else if (isShared) {
      if (props.shared && !props.match.params.sharedId) {
        setSequenceTableLoading(true);
        getSharedSeqResponse();
      }
    } else if (folderIdFromURL === "" && locationId === "") {
      showAllSequenceData();
    } else if (folderIdFromURL === "" && locationId) {
      makeAllSequenceDataApi();
    }
    setSortIconStatus("ASC");
    setActiveSort("CREATE_TS");
    // To hide the new folder or seq creation input box when page navigates.
    setNoSequence(false);
    setNosharedSequence(false);
    setCreateFolder(false);
    setCreateSeq(false);
    setCreateSeqPopup(false);
  }, [
    props.match.params.id,
    props.match.params.folderId,
    props.shared,
    props.match.params.sharedId
  ]);

  useEffect(() => {
    setProductDiscount(Utils.showProductDiscountBanner());
  }, [Utils.showProductDiscountBanner()]);

  useEffect(() => {
    constructBreadCrumbData(sequenceData);
  }, [sequenceStoreData?.allFolderResponse]);

  useEffect(() => {
    updateSequenceDataOnMoved();
  }, [sequenceStoreData.sequenceData]);

  useEffect(() => {
    initCalls();
  }, []);

  return (
    <div className={`sequencePage pageClass`}>
      <div className="sequenceCont pageCont">
        <div className="headerSection">
          <div className="breadCrumbLeftSection">
            <BreadCrumbComponent breadCrumbValue={breadcrumbArr} />
            {showSharedBadge && <SharedLabel />}
          </div>
          <div className="headerBtnContainer">
            <KnowMoreButton
              redirectUrl={
                "https://support.salesgear.io/en/articles/10485194-step-by-step-guide-to-creating-your-first-multi-channel-campaign"
              }
            />
            {!seqId && !isShared && (
              <AddNewBtnComponent
                enableDropdownMenuAction={enableDropdownMenu}
                toShowDropDown={showAddDropdown}
                dropdownOptions={dropdownOptions}
                hideDropdownMenu={hideDropdownMenu}
                {...props}
              />
            )}
          </div>
        </div>
        {!productDiscount && <PricingDiscountBanner />}
        <div className="sequenceSectionWrapper">
          <section
            className={`${
              seqId ? "sequenceDetailSection" : "sequenceSection"
            } ${!productDiscount ? "productDiscount" : ""}`}
          >
            {/* DndProvider hoisted outside the seqId ternary so it stays
              mounted across list↔detail navigation. Previously the provider
              was only inside the list branch; mounting/unmounting on every
              route change caused brief windows where two HTML5Backend
              instances coexisted and threw "Cannot have two HTML5 backends
              at the same time" from useDrop in the folder/list children. */}
            <DndProvider backend={HTML5Backend}>
            {seqId ? (
              <div className="rightSection">
                {showContactCard && (
                  <div
                    className={`contactCardSection ${
                      slideAnim ? "slideInFromBottom" : "slideOutToBottom"
                    } ${
                      !userDetail.pluginInstalled
                        ? "installPluginExtBannerShown"
                        : ""
                    }`}
                    id="contactCard"
                    key="contactCard"
                    ref={sequenceContactCardRef}
                  >
                    <ContactCard
                      cardType="sequence_contact"
                      page="Sequence Contacts Page"
                      contact={selectedContact}
                      closeCbk={closeContactCard}
                      isContactSlider={true}
                      isReloadCbk={reloadSequenceContactPage}
                    />
                  </div>
                )}
                {showSequenceProp && (
                  <SequenceProperties
                    {...props}
                    selectedContactCard={openContactCard}
                    setShowSharedBadge={setShowSharedBadge}
                    showUpgrade={inFreePlan && !checkEligibleSequenceCount()}
                    inFreePlan={inFreePlan}
                    taskEnabled={taskEnabled}
                  />
                )}
              </div>
            ) : (
              <>
                <div className={`${seqId ? "hideLeftSection" : "leftSection"}`}>
                  <FolderComponent
                    setCreateFolder={setCreateFolder}
                    setShowFolderLoader={setShowFolderLoader}
                    showcreateFolder={showcreateFolder}
                    showFolderLoader={showFolderLoader}
                    redirectToMySequence={redirectToMySequence}
                  />
                </div>
                <div className="rightSection">
                  {!showNoSequence && !showNoSharedSequence && !isShared && (
                    <CopilotBanner onClick={openCopilotForSequence} />
                  )}
                  {showNoSequence ? (
                    <NoSequenceComponent
                      showSequenceProp={showSequenceProp}
                      newSequenceBtnAction={openCopilotForSequence}
                      createManuallyAction={openCreateSequencePopup}
                      showUpgrade={inFreePlan && !checkEligibleSequenceCount()}
                    />
                  ) : showNoSharedSequence ? (
                    <NoSharedEntity title={"No shared sequences found"} />
                  ) : sequenceTableLoading ? (
                    <>
                      <SequenceTableLoading />
                      {sequenceStoreData.totalSequences >= 15 && (
                        <SequenceTableFooter
                          showAllSequenceData={showAllSequenceData}
                          getFolderSequenceResponse={getFolderSequenceResponse}
                          setSequenceTableLoading={setSequenceTableLoading}
                          getSharedSeqResponse={getSharedSeqResponse}
                        />
                      )}
                    </>
                  ) : (
                    <>
                      <SequenceTable
                        data={sequenceData}
                        folderIdFromURL={folderIdFromURL}
                        setSequenceData={setSequenceData}
                        setNoSequence={setNoSequence}
                        setCreateSeq={setCreateSeq}
                        setCreateSeqPopup={setCreateSeqPopup}
                        showCreateSeq={showCreateSeq}
                        showCreateSeqPopup={showCreateSeqPopup}
                        newSeqName={newSeqName}
                        checkAndUpdate={checkAndUpdate}
                        setNewSeqName={setNewSeqName}
                        setShowSharedBadge={setShowSharedBadge}
                        showUpgrade={
                          inFreePlan && !checkEligibleSequenceCount()
                        }
                        isShared={isShared}
                        sortSequence={sortSequence}
                        sortIconStatus={sortIconStatus}
                        activeSort={activeSort}
                        inFreePlan={inFreePlan}
                        taskEnabled={taskEnabled}
                      />
                      <SequenceTableFooter
                        showAllSequenceData={showAllSequenceData}
                        getFolderSequenceResponse={getFolderSequenceResponse}
                        setSequenceTableLoading={setSequenceTableLoading}
                        getSharedSeqResponse={getSharedSeqResponse}
                      />
                    </>
                  )}
                </div>
              </>
            )}
            </DndProvider>
          </section>
        </div>
      </div>
    </div>
  );
};

const SequenceTableFooter = (props = {}) => {
  const {
    showAllSequenceData,
    getFolderSequenceResponse,
    setSequenceTableLoading,
    getSharedSeqResponse
  } = props || {};

  const getSequencesByLimit = (limit = 10) => {
    sequenceStoreData.setPageLimit(limit);
    sequenceStoreData.setCurrentPage(1);
    setSequenceTableLoading(true);
    sequenceStoreData.setPaginationDataLoading(true);
    const payload = Utils.constructPaginationLimitPayload();
    if (sequenceStoreData.folderId) {
      payload.folderId = sequenceStoreData?.folderId;
      getFolderSequenceResponse(sequenceStoreData?.folderId, payload);
    } else if (sequenceStoreData?.isSharedSeqFolder) {
      payload.sharedFolder = true;
      getSharedSeqResponse(payload);
    } else {
      showAllSequenceData(payload);
    }
  };
  const pageLimitObj = {
    limitPerPage: sequenceStoreData?.pageLimit || 11,
    text: "Showing",
    totalCount: sequenceStoreData?.totalSequences || 0,
    cbk: getSequencesByLimit,
    background: true,
    customLimit: [15, 25, 50, 100]
  };

  const paginate = pageNoObj => {
    sequenceStoreData.setPaginationDataLoading(true);
    let pageNo = pageNoObj?.selected + 1 || 1;
    sequenceStoreData.setCurrentPage(pageNo);
    sequenceStoreData.setSequenceData("");
    setSequenceTableLoading(true);
    const payload = Utils.constructPaginationLimitPayload();
    if (sequenceStoreData.folderId) {
      payload.folderId = sequenceStoreData?.folderId;
      getFolderSequenceResponse(sequenceStoreData?.folderId, payload);
    } else if (sequenceStoreData?.isSharedSeqFolder) {
      payload.sharedFolder = true;
      getSharedSeqResponse(payload);
    } else {
      showAllSequenceData(payload);
    }
  };

  return (
    <>
      {sequenceStoreData?.totalSequences >= 15 && (
        <div className="metricsTableFooter">
          <PaginationComponent
            totalPages={sequenceStoreData?.totalPage || 1}
            callback={paginate}
            currentPage={sequenceStoreData?.currentPage || 1}
            loading={sequenceStoreData?.paginationDataLoading}
          />
          {!sequenceStoreData?.paginationDataLoading && (
            <PageLimit {...pageLimitObj} />
          )}
        </div>
      )}
    </>
  );
};

const AddNewBtnComponent = props => {
  return (
    <div className="add-new-dropdown">
      <ButtonComponent
        id="addNewSequence"
        name="addNewSequence"
        type="button"
        className=""
        btnText="Add New"
        icon={true}
        loader={false}
        iconName="keyboard_arrow_down"
        click={props.enableDropdownMenuAction}
      />
      <>
        {props.toShowDropDown ? (
          <>
            <DropdownMenuComponent
              options={props.dropdownOptions}
              referenceId=""
            />
            <div
              className="dropdown-overlay"
              onClick={props.hideDropdownMenu}
            />
          </>
        ) : (
          ""
        )}
      </>
    </div>
  );
};

const SharedLabel = () => {
  return (
    <div className="sharedLabel">
      <span className="sharedBadge">SHARED</span>
    </div>
  );
};

export default withRouter(observer(Sequence));
export { Sequence };
